import { useEffect, useState } from 'react';
import { ACTIVE, CANCELED, FAILED, PENDING } from '../../lib/shared/subscription-statuses';

const REPEAT_REQUEST_TIMEOUT = 2000;

function useStatusPurchase({ id, getStatus, signIn }) {
    const [purchaseData, setPurchaseData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getData = async (isInitial = false) => {
        const data = await getStatus(id);

        if (data.status === ACTIVE) {
            try {
                await signIn(id);
            } catch (e) {
                console.error(e, 'error');
            }
        }

        setPurchaseData(data);

        if (isInitial) {
            setIsLoading(false);
        }

        return data;
    };

    useEffect(() => {
        getData(true);
    }, []);

    useEffect(() => {
        let intervalId = null;

        if (purchaseData.status === PENDING) {
            intervalId = setInterval(async () => {
                const data = await getData();

                if (data.status === FAILED || data.status === ACTIVE || data.status === CANCELED) {
                    clearInterval(intervalId);

                    intervalId = null;
                }
            }, REPEAT_REQUEST_TIMEOUT);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [purchaseData.status]);

    return {
        purchaseData,
        isLoading
    };
}

export {
    useStatusPurchase
};
